import React from 'react';
import { Star, BadgeCheck } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Valentina Rossi',
    age: 36,
    city: 'Roma',
    text: 'Questo MegaPack mi ha cambiato il modo di lavorare. Prima passavo i weekend a cercare materiali, ora ho tutto pronto in pochi minuti.',
    avatar: 'https://i.pravatar.cc/150?img=47'
  }, {
    name: 'Luca Bianchi',
    age: 42,
    city: 'Milano',
    text: 'Materiale eccellente e molto ben organizzato. Perfetto per le lezioni di conversazione. I bonus sono fantastici.',
    avatar: 'https://i.pravatar.cc/150?img=11'
  }, {
    name: 'Marco Ferretti',
    age: 46,
    city: 'Firenze',
    text: "Insegno inglese da 18 anni e ho trovato tantissime idee fresche. I ragazzi aspettano l'ora di inglese con entusiasmo.",
    avatar: 'https://i.pravatar.cc/150?img=12'
  }];
  return <section className="py-14 px-4 bg-navy-800" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <div className="text-center mb-10" data-id="element-194">
          <div className="flex justify-center gap-1 text-gold-400 mb-3" data-id="element-195">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-196" />)}
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-197">
            Cosa dicono gli insegnanti
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-198">
          {testimonials.map((t, i) => <div key={i} className="bg-navy-900 p-6 rounded-2xl border border-navy-700" data-id="element-199">
              <div className="flex text-gold-400 mb-3" data-id="element-200">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-current" data-id="element-201" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-5 leading-relaxed" data-id="element-202">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-203">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full border-2 border-gold-500/30" data-id="element-204" />
                <div data-id="element-205">
                  <h4 className="text-white font-bold text-sm" data-id="element-206">
                    {t.name}, {t.age}
                  </h4>
                  <p className="text-gray-500 text-xs" data-id="element-207">{t.city}, Italia</p>
                  <div className="flex items-center gap-1 mt-0.5" data-id="element-208">
                    <BadgeCheck className="w-3 h-3 text-brand-green" data-id="element-209" />
                    <span className="text-brand-green text-[10px] font-medium" data-id="element-210">
                      Acquisto Verificato
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}